/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Text } from 'components/Text';
import { CarouselNavigation } from 'components';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { Content, LayoutCircle, Section, Spacer } from './styles';

const StepNavigation = ({ idOperation, stage, ignoreOperationRoot }) => {
  const history = useHistory();
  const loading = useContext(GlobalLoaderContext);
  const fitinsur = new FitinsurAPI();
  const authContext = useContext(GlobalAuthContext);
  const mc = new MessageCenter();
  const [isMasterPolicy, setIsMasterPolicy] = useState(null);

  function getOperationInfo() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationInfo(idOperation)
      .then(response => response.json())
      .then(response => {
        setIsMasterPolicy(response.isMasterPolicy || response.isMasterPolicyRoot);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${StepNavigation.name}\n` + error);
      });
  }

  useEffect(() => {
    getOperationInfo()
  }, [])

  const checkOperationRouteEnquiry = (res) => {
    let route = "";
    const { idOperationParent, idProduct, idOperation, idNavigation } = res.ret_value;
    console.log('{ idOperationParent, idProduct, idOperation, idNavigation }', { idOperationParent, idProduct, idOperation, idNavigation })
    switch (idNavigation) {
      case 1:
        route = `/edit-enquirity/${idProduct}/${idOperation}${idOperationParent ? `/${idOperationParent}` : ""}`;
        break;
      case 2:
        route = `/edit-enquirity/${idProduct}/${idOperation}${idOperationParent ? `/${idOperationParent}` : ""}`;
        break;
      case 3:
        route = `/broking/approval-nbi/${idOperation}`;
        break;
      case 4:
        if (idProduct == "16") {
          route = `/broking/select-markets/${idOperation}/${idProduct}`;
        } else {
          route = `/broking/select-markets/${idOperation}`;
        }
        break;
      case 5:
        route = `/broking/contacts-selection/${idOperation}`;
        break;
      case 6:
        route = `/broking/nbi-request/${idOperation}`;
        break;
      case 7:
        route = `/broking/send-nbi-request/${idOperation}`;
        break;
      case 8:
        route = `/broking/market-selection/${idOperation}`;
        break;
      case 9:
        route = `/broking/document-nbi-status/${idOperation}`;
        break;
      case 10:
        route = `/broking/approval-nbi-cv/${idOperation}`;
        break;
      case 11:
        route = `/broking/nbi-request-cv/${idOperation}`;
        break;
      case 12:
        route = `/broking/market-composition/${idOperation}`;
        break;
      case 13:
        route = `/broking/policy-pack-approval/${idOperation}`;
        break;
      case 14:
        route = `/broking/approval-policy-pack/${idOperation}`;
        break;
      case 15:
        route = `/broking/send-policy-pack-client/${idOperation}`;
        break;
      case 16:
        route = `/broking/send-approval-pack/${idOperation}`;
        break;
      case 17: //result.ret_value = {idNavigation: 17, dscNavigation: "Order to Bind Sent"};
        route = `/broking/send-order-to-bind/${idOperation}`;
        break;
      case 18: //result.ret_value = {idNavigation: 18, dscNavigation: "Order to Bind Approved"};
        route = `/broking/order-to-bind/${idOperation}`;
        break;
      case 19: //result.ret_value = {idNavigation: 19, dscNavigation: "Order to Bind Rejected"};
        route = `/broking/order-to-bind/${idOperation}`;
        break;
      case 20: //result.ret_value = {idNavigation: 20, dscNavigation: "Stamp Requested"};
        route = `/broking/stamps-status-list/${idOperation}`;
        break;
      case 21: //result.ret_value = {idNavigation: 21, dscNavigation: "Stamp Requested"};
        route = `/broking/payment-pack-send-approval/${idOperation}`;
        break;
      case 22: //result.ret_value = {idNavigation: 22, dscNavigation: "Stamp Requested"};
        route = `/broking/payment-pack-send-client-insurer/${idOperation}`;
        break;
      case 23: //result.ret_value = {idNavigation: 23, dscNavigation: "Stamp Requested"};
        route = `/broking/payment-pack-approval/${idOperation}`;
        break;
      case 99:
        route = `/edit-enquirity/${idProduct}/${idOperation}${idOperationParent ? `/${idOperationParent}` : ""}`;
        break;
    }

    if (route) {
      loading.stop();
      history.push(
        {
          pathname: route,
          state: res.ret_value.idNavigation == 99 ? { disabled: true, idProduct: idProduct } : { idProduct: idProduct }
        })
    } else {
      mc.error('NAVIGATION NOT DEFINED');
      loading.stop();
    }
  }

  const checkOperationRoute = (idOperation, step) => {
    if (stage === step) return;

    fitinsur.setAuthToken(authContext.token);
    loading.start();

    fitinsur.requestPolicyNavigation(idOperation).then(x => x.json()).then(res => {
      loading.stop();
      if (res.ret_code != 200) {
        mc.error(res.ret_msg_details);
        return;
      }

      let { route, idOperationRoot, idProduct, idDomain, idNavigation, lastOperationQuestionnaireId, isBound } = res.ret_value;
      if (idNavigation) route = checkOperationRouteEnquiry(res);

      if (step !== 3 || route) {
        if (step == 1) history.push(`/edit-enquirity/${idProduct}/${idOperation}${lastOperationQuestionnaireId != idOperation ? `?refOperation=${lastOperationQuestionnaireId}` : ''}`, { idProduct: idProduct, disabled: idOperationRoot === null, endorsement: idOperation || false });

        if (step == 2) {
          if (isMasterPolicy) {
            history.push(`/broking/select-markets/${idOperationRoot || idOperation}/${idProduct}`);
          } else if (stage === 3 || isBound) {
            history.push(`/broking/market-composition/${idDomain === 27 ? (idOperationRoot || idOperation) : idOperation}`, { idProduct: idProduct, disabled: idDomain !== 410, endorsement: idOperation || false });
          } else {
            history.push({ pathname: route })
          }
        }

        if (step == 3) history.push({ pathname: route })
      } else {
        // mc.error('NAVIGATION NOT DEFINED');
        loading.stop();
      }
    }).catch((e) => loading.stop());
  }

  return (
    <>
      <Content>
        <Section>
          <LayoutCircle isActive={stage === 1} onClick={() => checkOperationRoute(idOperation, 1)}> 1 </LayoutCircle>
          <Text className="d-none d-sm-block" spaceLeft={true} >ENQUIRY</Text>
        </Section>

        <Spacer className="d-sm-none"></Spacer>
        <Section>
          <LayoutCircle
            isActive={stage === 2} onClick={() => checkOperationRoute(idOperation, 2)} > 2 </LayoutCircle>
          <Text className="d-none d-sm-block" spaceLeft={true}>BROKING</Text>
        </Section>

        <Spacer className="d-sm-none"></Spacer>
        <Section>
          <LayoutCircle isActive={stage === 3} onClick={() => checkOperationRoute(idOperation, 3)}> 3 </LayoutCircle>
          <Text className="d-none d-sm-block" spaceLeft={true}>BINDING</Text>
        </Section>
      </Content>
    </>
  )
}

export default StepNavigation;